export default function Loading() {
  return (
    <div className="loading">
      <div className="loading_wrap">
        <svg
          viewBox="0 0 100 100"
          y="0"
          x="0"
          style={{
            height: "100%",
            width: "100%",
            background: " rgba(255, 255, 255,0)",
          }}
          width="200px"
          height="200px"
        >
          <g
            className="ldl-scale"
            style={{
              transformOrigin: "50% 50%",
              transform: "rotate(0deg) scale(0.8, 0.8)",
            }}
          >
            <g className="ldl-ani">
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: "50px 50px",
                    animation:
                      " 1.11111s linear -0.592593s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <circle
                    fill="#ffc28a"
                    r="10.89"
                    cy="20.89"
                    cx="27.778"
                    style={{ fill: "rgb(255, 194, 138)" }}
                  ></circle>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.62963s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M21.944 90a4.14 4.14 0 0 1-4.14-4.14V70.38a4.14 4.14 0 0 1 8.28 0v15.48a4.14 4.14 0 0 1-4.14 4.14z"
                    style={{ fill: "rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.666667s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M33.611 90a4.14 4.14 0 0 1-4.14-4.14V70.38a4.14 4.14 0 0 1 8.28 0v15.48a4.14 4.14 0 0 1-4.14 4.14z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.703704s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M7.64 55.765a4.14 4.14 0 0 1-1.018-5.766l9.73-13.899a4.14 4.14 0 1 1 6.783 4.749l-9.729 13.899a4.141 4.141 0 0 1-5.766 1.017z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear  -0.740741s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M47.915 55.764a4.14 4.14 0 0 0 1.018-5.766L39.204 36.1a4.14 4.14 0 1 0-6.783 4.749l9.729 13.899a4.14 4.14 0 0 0 5.765 1.016z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.777778s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path d="M41.578 39.492l-4.632-6.617-.048-.069-.068-.098a4.805 4.805 0 0 0-3.891-1.986H22.617c-1.6 0-3.016.784-3.891 1.986l-.068.097-.048.069-4.356 6.223 3.551 2.485v22.883h19.947V42.17l3.826-2.678z"></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.814815s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    d="M33.616 58.527l-.005-.001-.004.001H17.804v11.879h8.28v-2.804h3.387v2.804h8.28V58.527z"
                    fill="#3e4d8a"
                    style={{ fill: "   rgb(62, 77, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.851852s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <circle
                    fill="#ffc28a"
                    r="10.89"
                    cy="20.89"
                    cx="72.222"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></circle>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.888889s  infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M66.389 90a4.14 4.14 0 0 1-4.14-4.14V70.38a4.14 4.14 0 0 1 8.28 0v15.48a4.141 4.141 0 0 1-4.14 4.14z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.925926s  infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M78.056 90a4.14 4.14 0 0 1-4.14-4.14V70.38a4.14 4.14 0 0 1 8.28 0v15.48a4.14 4.14 0 0 1-4.14 4.14z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -0.962963s  infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M52.085 55.765a4.14 4.14 0 0 1-1.018-5.766L60.796 36.1a4.14 4.14 0 1 1 6.783 4.749L57.85 54.747a4.14 4.14 0 0 1-5.765 1.018z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -1s   infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ffc28a"
                    d="M92.36 55.764a4.14 4.14 0 0 0 1.018-5.766L83.648 36.1a4.14 4.14 0 1 0-6.783 4.749l9.729 13.899a4.14 4.14 0 0 0 5.766 1.016z"
                    style={{ fill: "  rgb(255, 194, 138)" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -1.03704s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path d="M82.196 58.527V42.17l3.826-2.678-4.632-6.617-.048-.069-.068-.098a4.805 4.805 0 0 0-3.891-1.986H67.061c-1.6 0-3.016.784-3.891 1.986l-.068.097-.048.069-4.356 6.223 3.551 2.485v16.944h19.947z"></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear  -1.07407s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    d="M82.196 58.527H62.249L57.248 70.38h29.948z"
                    fill="#ed1e79"
                    style={{ fill: "#ed1e79" }}
                  ></path>
                </g>
              </g>
              <g className="ldl-layer">
                <g
                  className="ldl-ani"
                  style={{
                    transform: "scale(0.91)",
                    transformOrigin: " 50px 50px",
                    animation:
                      "1.11111s linear -1.11111s infinite normal forwards running breath-2d587373-2577-4c67-9a48-75b93f465d84",
                  }}
                >
                  <path
                    fill="#ed1c24"
                    d="M69.917 44.495a9.53 9.53 0 0 0-.201-1.946c-.898-4.322-4.727-7.57-9.315-7.57a9.473 9.473 0 0 0-8.262 4.807 9.473 9.473 0 0 0-8.262-4.807c-4.588 0-8.417 3.248-9.315 7.57a9.523 9.523 0 0 0-.201 1.946c0 .146.01.289.016.433-.001.07-.005.14-.005.211 0 9.83 17.767 22.549 17.767 22.549s17.767-12.719 17.767-22.549c0-.071-.005-.14-.005-.211.006-.144.016-.287.016-.433z"
                    style={{ fill: " rgb(237, 28, 36)" }}
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}
